import React from 'react';

import LoginAuth from './LoginAuth';
import withModal from '../../global/modal/withModal';

export const LOGIN_AUTH_MODAL = 'modal/LOGIN_AUTH';

const LoginAuthModal = ({ actionProps, ...props }) => {
  const { onLoginCompleted, message, defaultPhone, defaultEmailAddress } =
    actionProps ?? {};
  return (
    <LoginAuth
      onLoginCompleted={onLoginCompleted}
      message={message}
      defaultPhone={defaultPhone}
      defaultEmailAddress={defaultEmailAddress}
      {...props}
    />
  );
};

export default withModal(LoginAuthModal, {
  name: LOGIN_AUTH_MODAL,
  size: 'sm',
  type: 'full',
});
